<template>
    <app-admin-layout :ask-for-quote="askForQuote">
        <Head>
            <title>{{ askForQuote.pfnumber }} - Bestätigung</title>
        </Head>

        <div class="ask-for-quote ask-for-quote--confirmation">

            <ask-for-quote-header :askForQuote="askForQuote"/>

            <div class="ask-for-quote--content">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <card>
                                <card-header>
                                    <card-overline>Kundenbestellung</card-overline>
                                </card-header>
                                <card-content>
                                    <table class="table table--striped table--card">
                                        <thead>
                                            <tr>
                                                <th>Bestelldatum</th>
                                                <th>Rabatt</th>
                                                <th>Gesamt netto</th>
                                                <th>Angebotspreis</th>
                                                <th>Lieferzeit</th>
                                            </tr>
                                        </thead>
                                        <tbody v-if="clientOrder">
                                            <tr>
                                                <td>{{ clientOrder.created_at }}</td>
                                                <td>{{ clientOrder.rebate }}</td>
                                                <td>{{ clientOrder.net_price }}</td>
                                                <td>{{ clientOrder.offer_price }}</td>
                                                <td>{{ clientOrder.delivery_days_client }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </card-content>
                            </card>
                        </div>
                        <div class="col">
                            <div class="row">
                                <div class="col">
                                    <card>
                                        <card-header>
                                            <card-overline>Produzentenbestätigung</card-overline>
                                        </card-header>
                                        <card-content>
                                            <table class="table table--striped table--card">
                                                <thead>
                                                <tr>
                                                    <th>Bestelldatum</th>
                                                    <th>Lieferdatum</th>
                                                    <th>Liefermenge</th>
                                                    <th>P-Angebotspreis</th>
                                                    <th>bestätigt</th>
                                                    <th>Produktionsdatum</th>
                                                    <th>storniert</th>
                                                    <th>Kommentar</th>
                                                </tr>
                                                </thead>
                                                <tbody v-if="producerOrder">
                                                <tr>
                                                    <td>{{ producerOrder.created_at }} </td>
                                                    <td>{{ producerOrder.delivery_date }} </td>
                                                    <td>{{ producerOrder.amount }} </td>
                                                    <td>{{ producerOrder.price }} </td>
                                                    <td>{{ producerOrder.accepted_at }} </td>
                                                    <td>{{ producerOrder.planned_production_start_at }} </td>
                                                    <td>{{ producerOrder.canceled_at }} </td>
                                                    <td>{{ producerOrder.cancellation_comment }} </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </card-content>
                                    </card>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <card>
                                        <card-header>
                                            <card-overline>Bestätigungsmahnung</card-overline>
                                        </card-header>
                                        <card-content>
                                            <table class="table table--striped table--card">
                                                <thead>
                                                <tr>
                                                    <th>Datum</th>
                                                    <th>Kommentar</th>
                                                    <th>Operator</th>
                                                    <th></th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="reminder in reminders" :key="reminder.index">
                                                    <td>{{ reminder.created_at_string }}</td>
                                                    <td>{{ reminder.comment }}</td>
                                                    <td>{{ reminder?.admin_user?.name }}</td>
                                                    <td class="small">
                                                        <form-button icon="document-file-eye" dense="true" @click="viewReminderModal = true; showReminder = reminder" />
                                                        <form-button type="button" dense="true"
                                                                     @click="deleteDialog = true; deleteRoute = this.$$route('ask-for-quote.confirmation.reminder.delete', {'askForQuote': this.askForQuote, 'reminder': reminder.id})"
                                                                     icon="trash-delete-bin-2"/>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>

                                            <modal-dialog title="Bestätigungsmahnung löschen" text="Möchten Sie die Bestätigungsmahnung wirklich löschen?"
                                                          confirm="löschen" v-if="deleteDialog" @closeDialog="deleteDialog = false;"
                                                          @confirmDialog="deleteMethod"/>

                                            <modal v-if="viewReminderModal" width="small">
                                                <modal-header>
                                                    Bestätigungsmahnung
                                                </modal-header>
                                                <modal-content>
                                                    <description-group grid="grid">
                                                        <description-element :caption="showReminder.created_at" title="Mahnungsdatum" is-date="true" />
                                                        <description-element :caption="showReminder.admin_user.name" title="Operator" />
                                                    </description-group>
                                                    <hr v-if="showReminder.comment">
                                                    <span class="caption" v-if="showReminder.comment">
                                                        Kommentar
                                                    </span>
                                                    <p v-if="showReminder.comment">{{ showReminder.comment }}</p>
                                                    <hr>
                                                    <div v-html="showReminder.text" />
                                                </modal-content>
                                                <modal-actions @closeDialog="viewReminderModal = false; showReminder = null;" />
                                            </modal>
                                        </card-content>
                                    </card>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <form-actions>
                                        <form-button class="btn--block" icon="calendar-add-circle" @click="reminderModal = !reminderModal" :disabled="!clientOrder || producerOrderConfirmed || disabledTab" color="secondary">Neue Bestätigungsmahnung</form-button>
                                    </form-actions>
                                    <producer-order-confirmation-reminder-modal :ask-for-quote="askForQuote" v-if="reminderModal" @closeDialog="reminderModal = false" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-admin-layout>
</template>

<script>
import AppAdminLayout from '@partfactory/Layouts/AppAdminLayout';
import AskForQuoteHeader from '@partfactory/Pages/Admin/AskForQuote/Header/AskForQuoteHeader';
import Card from '@partfactory/Shared/Card/Card';
import CardHeader from '@partfactory/Shared/Card/CardHeader';
import CardOverline from '@partfactory/Shared/Card/CardOverline';
import CardContent from '@partfactory/Shared/Card/CardContent';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormActions from '@partfactory/Shared/Form/FormActions';
import ProducerOrderConfirmationReminderModal
    from '@partfactory/Pages/Admin/AskForQuote/Modals/ProducerOrderConfirmationReminderModal';
import Modal from '@partfactory/Shared/Modal/Modal';
import ModalHeader from '@partfactory/Shared/Modal/ModalHeader';
import ModalActions from '@partfactory/Shared/Modal/ModalActions';
import ModalContent from '@partfactory/Shared/Modal/ModalContent';
import DescriptionGroup from '@partfactory/Shared/Elements/DescriptionGroup';
import DescriptionElement from '@partfactory/Shared/Elements/DescriptionElement';
import ModalDialog from '@partfactory/Shared/Modal/ModalDialog';

export default {
    name: 'Confirmation',
    components: {
        ModalDialog,
        DescriptionElement,
        DescriptionGroup,
        ModalContent,
        ModalActions,
        ModalHeader,
        Modal,
        ProducerOrderConfirmationReminderModal,
        FormActions, FormButton, CardContent, CardOverline, CardHeader, Card, AskForQuoteHeader, AppAdminLayout},
    props: {
        askForQuote: Object,
    },
    data() {
        return {
            reminderModal: false,
            viewReminderModal: false,
            showReminder: null,
            deleteDialog: false,
            deleteRoute: null,
        };
    },
    computed: {
        clientOrder() {

            if (!this.askForQuote?.client_order?.created_at)
                return null;

            let clientOrder = {};
            clientOrder.created_at = this.$date(this.askForQuote?.client_order?.created_at);
            clientOrder.rebate = this.$currency(this.askForQuote?.client_order?.client_offer.pre_rebate_offer);
            clientOrder.net_price = this.$currency(this.askForQuote?.client_order?.client_offer.net_price);
            clientOrder.offer_price = this.$currency(this.askForQuote?.client_order?.client_offer.offer_price);
            clientOrder.delivery_days_client = this.askForQuote?.client_order?.client_offer.delivery_days_client + ' Tage';

            return clientOrder;
        },
        producerOrder() {

            if (!this.askForQuote?.producer_order?.created_at)
                return null;

            let producerOrder = {};
            producerOrder.created_at = this.$date(this.askForQuote?.producer_order?.created_at);
            producerOrder.delivery_date = this.$date(this.askForQuote?.producer_order?.delivery_date);
            producerOrder.amount = this.askForQuote?.producer_order?.amount;
            producerOrder.price = this.$currency(this.askForQuote?.producer_order?.price);
            producerOrder.accepted_at = this.askForQuote?.producer_order?.accepted_at ? this.$date(this.askForQuote?.producer_order?.accepted_at) : '-';
            producerOrder.planned_production_start_at = this.askForQuote?.producer_order?.planned_production_start_at ? this.$date(this.askForQuote?.producer_order?.planned_production_start_at) : '-';
            producerOrder.canceled_at = this.askForQuote?.producer_order?.canceled_at ? this.$date(this.askForQuote?.producer_order?.canceled_at) : '-';
            producerOrder.cancellation_comment = this.askForQuote?.producer_order?.cancellation_comment;

            return producerOrder;
        },
        producerOrderConfirmed() {
            return !! this.askForQuote?.producer_order?.accepted_at;
        },
        reminders() {
            return this.askForQuote.reminders.map(reminder => {
                reminder.created_at_string = this.$date(reminder.created_at);
                return reminder;
            });
        },
        disabledTab() {
            return this.$disabledTab(this.askForQuote.status, 9);
        },
    },
    methods: {
        deleteMethod() {
            this.$inertia.delete(this.deleteRoute);
            this.deleteRoute = null;
            this.deleteDialog = false;
        },
    },
};
</script>
